import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-site",
  "use": "icon-site-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-site\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M703.7 644.4v-84H550.3V459.6h153.4v-84h-41.9l23.2-94.1h-86.5l-23.2 94.1H453.8l-26.1-94.1h-87.2l26.2 94.1H316v84h150.3v100.8H316v84h150.3v127h84v-127z\" p-id=\"20626\" />\n  <path d=\"M931.2 339.3c-22.9-54.2-55.7-102.8-97.5-144.6s-90.4-74.6-144.6-97.5C633 73.5 573.4 61.5 512 61.5s-121 12-177.1 35.8c-54.2 22.9-102.8 55.7-144.6 97.5s-74.6 90.4-97.5 144.6C69.1 395.4 57 455 57 516.4s12 121 35.8 177.1c22.9 54.2 55.7 102.8 97.5 144.6s90.4 74.6 144.6 97.5c42 17.8 86 29 131.2 33.5v-84.6c-183-22.7-325-179.1-325-368.1 0-204.5 166.4-371 371-371s371 166.4 371 371c0 191.6-146 349.7-332.5 369v84.4c47.8-4 94.3-15.4 138.7-34.2 54.2-22.9 102.8-55.7 144.6-97.5s74.6-90.4 97.5-144.6c23.7-56.1 35.8-115.7 35.8-177.1s-12.3-121-36-177.1z\" p-id=\"20627\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/site.svg
// module id = 6Ehg
// module chunks = 13